import * as moment from 'moment';

import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

export class DatePickerFormatter extends NgbDateParserFormatter {

  parse(value: string): NgbDate {
    if (value && (10 === value.length)) {
      const date = moment(value, 'MM/DD/YYYY');
      return new NgbDate( date.year(), date.month() + 1, date.date());
    }
    return null;
  }

  format(date: NgbDate): string {
    if (date) {
      return moment({year: date.year, month: date.month - 1, day: date.day}).format('MM/DD/YYYY');
    }
    return null;
  }

}
